import { IconButton } from '@droplet-tech-code/core-elements/module/ui/Button';
import { Text } from '@droplet-tech-code/core-elements/module/ui/Text';
import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';

import { PageHeader } from '~/components/Page/Page.Header';
import { translate } from '~/utils/translation.utils';

export const PurchasesCRCListHeader = ({
  companyResCode,
  onReset,
  onPress,
}: {
  companyResCode: string;
  onReset: () => void;
  onPress?: () => void;
}) => {
  return (
    <PageHeader
      title={translate('purchases.purchasesByCompanyResCode')}
      withBack={isNativeMobile}
      iconRight={{
        color: 'monochrome',
        icon: 'refresh',
        onPress,
      }}
      Subtitle={
        <Text.Small>{`${translate(
          'purchases.companyReservationCode',
        )} "${companyResCode}"`}</Text.Small>
      }
      childRight={<IconButton icon="reset" color="monochrome" onPress={onReset} />}
    />
  );
};
